import { all } from "redux-saga/effects";
import VideoSaga from "../common/video/VideoSaga";
import SearchSaga from "../viewer/search/SearchSaga";
import PresentersSaga from "../presenters/PresentersSaga";
import UserSaga from "../user/UserSaga";
import HomePageSaga from "../common/homePage/HomePageSaga";
import ProgramSaga from "../stores/program/ProgramSaga";
import ExProjectSaga from "../store/sagas/ExProjectSaga";
import ExVideoSaga from "../store/sagas/ExVideoSaga";
import SlideSaga from "../store/sagas/SlideSaga";
import StatisticsSaga from "../store/sagas/StatisticsSaga";
import TimelineSaga from "../studio/store/sagas/TimelineSaga";
import DirectorySaga from "../studio/store/sagas/DirectorySaga";
import TemplateSaga from "../studio/store/sagas/TemplateSaga";
import VideoInfoSaga from "../studio/store/sagas/VideoInfoSaga";
import DocumentSaga from "../store/sagas/DocumentSaga";

export default function* rootSaga() {
    yield all([
        HomePageSaga(),
        VideoSaga(),
        SearchSaga(),
        PresentersSaga(),
        UserSaga(),
        ProgramSaga(),
        ExProjectSaga(),
        ExVideoSaga(),
        SlideSaga(),
        StatisticsSaga(),
        TimelineSaga(),
        DirectorySaga(),
        TemplateSaga(),
        VideoInfoSaga(),
        DocumentSaga(),
    ]);
}
